import React from 'react'
import "./footer.css"

const Footer = () => {
  return (
    <div className='footer'>
      <div className="fList">
        <ul className="fItems">
          <li className="fItem">Countries</li>
          <li className="fItem">Regions</li>
          <li className="fItem">Cities</li>
          <li className="fItem">Districts</li>
          <li className="fItem">Airports</li>
          <li className="fItem">Hotels</li>
          <li className="fItem">Places of interest</li>
        </ul>
        <ul className="fItems">
        <li className="fItem">Homes </li>
          <li className="fItem">Apartments </li>
          <li className="fItem">Resorts </li>
          <li className="fItem">Villas</li>
          <li className="fItem">Hostels</li>
          <li className="fItem">Guest houses</li>
        </ul>
        <ul className="fItems">
        <li className="fItem">Unique places to stay </li>
          <li className="fItem">Reviews</li>
          <li className="fItem">Unpacked: Travel articles </li>
          <li className="fItem">Travel communities </li>
          <li className="fItem">Seasonal and holiday deals </li>
        </ul>
        <ul className="fItems">
        <li className="fItem">Car rental </li>
          <li className="fItem">Flight Finder</li>
          <li className="fItem">Restaurant reservations </li>
          <li className="fItem">Travel Agents </li>
        </ul>
        <ul className="fItems">
        <li className="fItem">Curtomer Service</li>
          <li className="fItem">Partner Help</li>
          <li className="fItem">Careers</li>
          <li className="fItem">Sustainability</li>
          <li className="fItem">Press center</li>
          <li className="fItem">Safety Resource Center</li>
          <li className="fItem">Investor relations</li>
          <li className="fItem">Terms & conditions</li>
        </ul>
      </div>
      <span className="cRight">Copyright © July 6th–2023 Western-Booking. All rights reserved.
</span>
    </div>
  )
}

export default Footer